import React from "react";
import "./DdugkyPage.css";
import BannerImage from "../Component/Deen_Dayal_Upadhyaya_Grameen_Kaushalya_Yojana.png"; // ✅ Replace with your actual banner image

const DdugkyPage = () => {
  return (
    <div className="ddugky-page">
      {/* 🔹 Banner Section */}
      <div className="ddugky-banner">
        <img src={BannerImage} alt="DDU-GKY Banner" className="banner-img" />
       
      </div>

      {/* 🔹 Content Section */}
      <div className="container py-5 ddugky-content">
        <h2 className="text-primary fw-bold mb-4 text-center">
          About DDU-GKY (Deen Dayal Upadhyaya Grameen Kaushalya Yojana)
        </h2>

        <p>
          The Deen Dayal Upadhyaya Grameen Kaushalya Yojana (DDU-GKY) is an initiative by the
          Ministry of Rural Development, Government of India, aimed at transforming the rural youth
          into an employable and skilled workforce. The mission focuses on providing livelihood
          opportunities for young people from rural backgrounds, helping them gain meaningful
          employment in various sectors across India and abroad.
        </p>

        <p>
          As a proud training partner of DDU-GKY, CPIT is committed to empowering rural youth by
          delivering high-quality, job-oriented skill development programs. The courses offered
          under this scheme cover a wide range of industries, including Information Technology,
          Retail, Hospitality, Communication, and Technical Trades. Each program integrates
          practical learning, hands-on training, and real-world exposure to ensure that students
          are fully prepared for professional success.
        </p>

        <p>
          CPIT ensures that every student under the DDU-GKY program receives comprehensive
          guidance—from basic skill enhancement to advanced technical education. Regular workshops,
          industry interactions, and placement assistance are provided to create a bridge between
          training and employment. This structured approach not only improves employability but also
          enhances students’ confidence and adaptability in real job environments.
        </p>

        <p>
          After successful completion, candidates receive government-recognized certificates and
          placement support to secure stable jobs in reputed organizations. The DDU-GKY initiative,
          implemented at CPIT, continues to make a significant impact by uplifting rural youth,
          promoting self-reliance, and contributing to the socio-economic growth of the nation.
        </p>
      </div>
    </div>
  );
};

export default DdugkyPage;
